import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FirebaseAppUser } from '../types/Types.ts'

export interface FirebaseAuthState {
  user: FirebaseAppUser | null
  needsRegistration: boolean | false
  loading: boolean
}

const initialState: FirebaseAuthState = {
  user: null,
  needsRegistration: false,
  loading: true,
}

export const firebaseAuthSlice = createSlice({
  name: 'firebaseAuth',
  initialState,
  reducers: {
    setFirebaseUser: (state, action: PayloadAction<FirebaseAppUser | null>) => {
      state.user = action.payload
      state.loading = false
    },
    setNeedsRegistration: (state, action: PayloadAction<boolean>) => {
      state.needsRegistration = action.payload
    },
  },
})

export const { setFirebaseUser, setNeedsRegistration } =
  firebaseAuthSlice.actions
export default firebaseAuthSlice.reducer
